import CampaignSummarySlide from "./CampaignSummarySlide";

export default CampaignSummarySlide;
